import {
    AnyFinancialEntity,
    getFEBaseConfig,
    getName,
} from '../../financialEntities';
import { PartnerInfo } from '../../graphql/generated';
import { getPreferredOrFirstName, UserInfo } from '../user';
import { getInstitutionName } from './helpers';

export interface FinancialEntityMaskBaseProps {
    fe: AnyFinancialEntity;
    showName?: boolean;
    showMask?: boolean;
    asString?: boolean;
    showOwnership?: boolean;
}

export const getFinancialEntityWithMaskParams = ({
    fe,
    userInfo,
    partnerInfo,
}: {
    fe: AnyFinancialEntity;
    userInfo: UserInfo;
    partnerInfo: PartnerInfo | undefined | null;
}) => {
    const name =
        fe.type === 'PlentyGoalAccount'
            ? getName(fe)
            : fe.name ||
              getInstitutionName(fe) ||
              getFEBaseConfig(fe.type).title;
    const mask = fe.mask;
    let ownershipStr = '';
    if (fe.ownershipType === 'JOINT') {
        ownershipStr = 'Joint';
    } else if (fe.isMine) {
        ownershipStr = getPreferredOrFirstName(userInfo) ?? '';
    } else if (partnerInfo) {
        ownershipStr = getPreferredOrFirstName(partnerInfo) ?? '';
    }

    return {
        name,
        mask,
        ownershipStr,
    };
};
